/**
 * Builds the "Download Brochure" URL.
 *
 * Points to the unified `/api/ws/staticBrochure/{slug}` endpoint. The backend
 * decides whether to serve a static PDF (when a static brochure is set on the
 * course/template) or fall back to dynamic brochure generation, so the CRM no
 * longer needs to distinguish static vs. dynamic itself.
 */
export default function getBrochureURL(ecommerceSiteURL, slug, ecommerceKey, lang) {
    const langParam = lang ? `&lang=${lang}` : "";

    return `${ecommerceSiteURL}/api/ws/staticBrochure/${slug}?ecommerceKey=${ecommerceKey}${langParam}`;
}
